require('./myProfileDocumentationMoreOptionsButton.scss');

// @vendors
const React = require('react');

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKIconTask } = require('commonsComponents/OKIconTask');
const WebappRender = require('components/conditionalRender/webappRender')

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');
const { webappClassName } = require('utilities/conditionals/conditionalClassname')
import { recordLinkV2 } from "utilities/tagging";


class MyProfileDocumentationMoreOptionsButton extends React.Component {
    buildMoreOptions() {

        let options = [
            {
                link: `/myprofile/documentation/legalCorrespondence`,
                text: formatText('profileDocumentation-legalCorrespondence')
            },
            {
                link: `/myprofile/documentation/annualInformation`,
                text: formatText('profileDocumentation-infoAnual')
            },
            {
                link: '/myprofile/documentation/uploadDocumentation',
                text: formatText('profileDocumentation-uploadDocumentation'),
                handleClick: () => {
                    recordLinkV2({
                        categoriaEvento: "documentos",
                        accionEvento: "mas opciones",
                        etiquetaEvento: "subida de documentacion"
                    })
                }
            }
        ];

        return removeCurrentSectionOption(options);
    }

    render() {
        const moreOptions = this.buildMoreOptions();
        const targetContainerClass = webappClassName('hidden-xs');
        const contentContainerClass = webappClassName('documentation-header__more-options-button');

        const targetElement = (
            <div>
                <div className={targetContainerClass}>
                    <OKButton
                        modifier="ghost"
                        inverse={true}
                        rightIcon="icon-dropdown-abrir documentation-header__icon-dropdown"
                    >
                        <FormattedText value="profileDocumentation-moreOptions" />
                    </OKButton>
                </div>
                <WebappRender>
                    <div className="visible-xs">
                        <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
                    </div>
                </WebappRender>
            </div>
        );

        const popoverMenu = (
            <PopoverMenu
                target={targetElement}
                items={moreOptions}
                placement="bottomRight"
            />
        );

        return (!__CONTACT_CENTER__) ?
            <div className={contentContainerClass}>
                {popoverMenu}
            </div>
            :
            <React.Fragment>
                {popoverMenu}
            </React.Fragment>
    }
}

module.exports = MyProfileDocumentationMoreOptionsButton;
